<template>
<div>
    <b-card-group deck class="mb-3">
        <b-row class="w-100 m-0">
            <b-col v-for="form in forms" :key="form.id" cols="12" md="6" lg="4" class="mb-3">
                <b-card class="h-100 card-accent-secondary" no-body>
                    <b-card-body class="d-flex flex-column">
                        <div class="d-flex align-items-start mb-2">
                            <i :class="['fa-light', form.icon, 'fa-2x', 'mr-2', 'text-primary']"></i>
                            <div>
                                <h5 class="mb-1">{{ form.title }}</h5>
                                <small class="text-muted">{{ form.subtitle }}</small>
                            </div>
                        </div>
                        <p class="small text-muted flex-grow-1">{{ form.description }}</p>
                        <div>
                            <b-button size="sm" variant="primary" @click="open(form.id)">
                                <i class="fa-solid fa-pen-to-square"></i> Fill &amp; Download
                            </b-button>
                            <b-button size="sm" variant="outline-secondary" :href="form.templateUrl" target="_blank">
                                <i class="fa-solid fa-file-pdf"></i> Blank PDF
                            </b-button>
                        </div>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
    </b-card-group>

    <!-- One modal per form so each has its own state -->
    <b-modal v-for="form in forms" :key="`modal-${form.id}`"
             :id="`patient-form-modal-${form.id}`"
             :title="form.title"
             size="xl"
             hide-footer
             scrollable>
        <component v-if="activeForm === form.id"
                   :is="form.component"
                   :demographics="demographics"
                   @close="close" />
    </b-modal>
</div>
</template>

<script>
import { mapGetters } from "vuex"
import TabExtension from "./TabExtension"

import FalabMedicalForm from "./forms/FalabMedicalForm"
import NisSicknessForm from "./forms/NisSicknessForm"
import TeacherSickLeaveForm from "./forms/TeacherSickLeaveForm"
import DemeraraMutualForm from "./forms/DemeraraMutualForm"
import GtmHealthForm from "./forms/GtmHealthForm"
import PublicAssistanceForm from "./forms/PublicAssistanceForm"

export default TabExtension.extend({
    name: "forms-base",
    components: {
        FalabMedicalForm,
        NisSicknessForm,
        TeacherSickLeaveForm,
        DemeraraMutualForm,
        GtmHealthForm,
        PublicAssistanceForm,
    },
    data() {
        return {
            activeForm: null,
            forms: [
                {
                    id: "falab",
                    title: "FALAB Medical Report",
                    subtitle: "Firearms Licensing Approval Board",
                    description: "Medical/physical examination for a firearm licence application or renewal.",
                    icon: "fa-shield-halved",
                    component: "FalabMedicalForm",
                    templateUrl: "/forms/falab-medical.pdf",
                },
                {
                    id: "nis-sickness",
                    title: "NIS Sickness Benefit",
                    subtitle: "National Insurance & Social Security",
                    description: "Claim for sickness benefit with attached medical certificate.",
                    icon: "fa-notes-medical",
                    component: "NisSicknessForm",
                    templateUrl: "/forms/nis-sickness-benefit.pdf",
                },
                {
                    id: "teacher-sick-leave",
                    title: "Teacher's Sick Leave",
                    subtitle: "Medical Certificate",
                    description: "Short medical certificate for a teacher's sick leave request.",
                    icon: "fa-chalkboard-user",
                    component: "TeacherSickLeaveForm",
                    templateUrl: "/forms/teacher-sick-leave.pdf",
                },
                {
                    id: "demerara-mutual",
                    title: "Demerara Mutual Health Claim",
                    subtitle: "Demerara Mutual Life",
                    description: "Health claim form for medical, dental and vision services.",
                    icon: "fa-file-medical",
                    component: "DemeraraMutualForm",
                    templateUrl: "/forms/demerara-mutual-health-claim.pdf",
                },
                {
                    id: "gtm-health",
                    title: "GTM Health Insurance Claim",
                    subtitle: "Guyana & Trinidad Mutual",
                    description: "Health insurance claim form completed by doctor/dentist/optometrist/pharmacist.",
                    icon: "fa-hand-holding-medical",
                    component: "GtmHealthForm",
                    templateUrl: "/forms/gtm-health-insurance-claim.pdf",
                },
                {
                    id: "public-assistance",
                    title: "Public Assistance Medical",
                    subtitle: "Ministry of Human Services & Social Security",
                    description: "Application for Public Assistance — Medical / Economical.",
                    icon: "fa-hand-holding-heart",
                    component: "PublicAssistanceForm",
                    templateUrl: "/forms/public-assistance-medical.pdf",
                },
            ],
        }
    },
    computed: {
        ...mapGetters("patients", ["getPatientDemographics"]),
        demographics() {
            return this.getPatientDemographics()
        },
    },
    methods: {
        open(id) {
            this.activeForm = id
            this.$bvModal.show(`patient-form-modal-${id}`)
        },
        close() {
            if (this.activeForm) {
                this.$bvModal.hide(`patient-form-modal-${this.activeForm}`)
                this.activeForm = null
            }
        },
    },
})
</script>
